import { useEffect, useRef, useState } from "react";
// import "../Menu.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { adminLogin, login } from "../redux/actions/authAction";
import Footer from "./footer";
import Navbar from "./navbar";

const LENGTH_OF_TEXT = 200;

const Login = () => {
	const initialState = { email: "", password: "" };
	const [userData, setUserData] = useState(initialState);
	const [userType, setUserType] = useState(false);
	const { email, password } = userData;
	const [showPassword, setShowPassword] = useState(false);
	const hasRedirected = useRef(false);

	const { auth } = useSelector((state) => state);
	const dispatch = useDispatch();
	const history = useHistory();

	useEffect(() => {
		if (auth.user !== undefined && !hasRedirected.current) {
			hasRedirected.current = true;
			// Check if there's a stored redirect URL
			const redirectUrl = localStorage.getItem("redirectAfterLogin");
			console.log("redirectUrl", redirectUrl);
			if (redirectUrl) {
				// Clear the stored URL and redirect
				localStorage.removeItem("redirectAfterLogin");
				console.log("loginRedirecting to:", redirectUrl);
				window.location.href = redirectUrl;
			} else {
				// Default redirect to courses page
				console.log(
					"login No redirect URL found, going to default courses page",
				);
				// window.location.href = "./mycources"
				window.location.href =
					"./courses/9ae8b71c-dd3f-4fad-b1ee-e872f951e7af?tab=mycourses";
			}
		}
	}, [auth.user]);

	const handleChangeInput = (e) => {
		const { name, value } = e.target;
		setUserData({ ...userData, [name]: value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		const loginData = { ...userData, email: userData.email.toLowerCase() };
		if (!userType) {
			dispatch(login(loginData));
		} else {
			dispatch(adminLogin(loginData));
		}
	};

	return (
		<>
			<Navbar />
			<div style={{ backgroundColor: "white" }}>
				<div className="spacer"></div>
				<div id="testlogin">
					<div className="row">
						<div className="col-1"></div>
						<div className="col-10 block">
							<form onSubmit={handleSubmit} autoComplete="off">
								<div className="row">
									<label className="email-label">
										Email address - for already registered users
									</label>
									<div className="email-input">
										<input
											className="email-input"
											style={{ border: "1px solid #dee2e6" }}
											type="email"
											onChange={handleChangeInput}
											value={email}
											name="email"
											required
											maxLength={LENGTH_OF_TEXT}
										/>
									</div>
								</div>
								<div className="row">
									<div className="d-flex justify-content-between align-items-center w-100">
										<label className="password-label">Password</label>
										<span
											className="toggle-password d-flex align-items-center"
											onClick={() => setShowPassword(!showPassword)}>
											{showPassword ? (
												<>
													<FaEyeSlash className="me-1" />
													Hide Password
												</>
											) : (
												<>
													<FaEye className="me-1" />
													Show Password
												</>
											)}
										</span>
									</div>
								</div>
								<div className="row">
									<div className="password-input">
										<input
											className="password-input"
											style={{ border: "1px solid #dee2e6" }}
											type={showPassword ? "text" : "password"}
											onChange={handleChangeInput}
											value={password}
											autoComplete="off"
											name="password"
											required
											maxLength={LENGTH_OF_TEXT}
										/>
									</div>
								</div>
								<button className="login-button mt-3" type="submit">
									Log In
								</button>
							</form>
						</div>
						<div className="col-1"></div>
					</div>
					<div className="row">
						<div className="col-1"></div>
						<div className="col-10 text-left join">
							For new users -{" "}
							<Link to="/register">
								<button className="Lost-button fw-bolder" type="button">
									Create Account
								</button>
							</Link>
							{" | "}
							<Link to="/lostpassword">
								<button className="Lost-button-2 fw-bolder" type="button">
									Forgot Password
								</button>
							</Link>
						</div>
						<div className="col-1"></div>
					</div>
				</div>
				<div className="spacer"></div>
			</div>
			<Footer />
		</>
	);
};

export default Login;
